(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ManualHelp', ManualHelp);

    ManualHelp.$inject = ['$resource'];

    function ManualHelp($resource) {
        return $resource('api/help/manual/documents/:key', {key: '@key'}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'indexDocuments': {
                method: 'POST',
                url: 'api/help/manual/index'
            },
            'chatAssistant': {
                method: 'POST',
                url: 'api/help/manual/chat',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'getAssistantUsage': {
                method: 'GET',
                url: 'api/help/manual/usage'
            }
        });
    }
})();
